<!-- eslint-disable vue/no-mutating-props -->
<template>
  <form @submit.prevent="gonder">
    <div class="row">
      <!-- İş Durumu -->
      <div class="row">
        <label class="col-4 pt-2" :class="{ 'text-danger': formHatalar.durum }">
          İş Durumu:
        </label>
        <div class="top-label col-8 mb-2" :class="{ 'text-danger': formHatalar.durum }">
          <v-select 
            v-model="localFormData.durum" 
            :options="durumlar" 
            label="ad" 
            :reduce="tur => tur.id"
            placeholder="Durum seçin" 
          />
          <span v-if="formHatalar.durum" class="error">{{ formHatalar.durum }}</span>
        </div>
      </div>

        <!-- Aciliyet Durumu -->
    <div class="row mb-2">
      <label class="col-4 pt-2" :class="{ 'text-danger': formHatalar.aciliyet }">
        Aciliyet Durumu:
      </label>
      <div class="form-floating col-8 mb-2 " :class="{ 'text-danger': formHatalar.aciliyet }">
        <v-select 
          v-model="localFormData.aciliyet" 
          :options="aciliyetler" 
          label="ad" 
          :reduce="ac => ac.id"
          placeholder="Aciliyet durumu seçin" 
        />
        <span v-if="formHatalar.aciliyet" class="error">{{ formHatalar.aciliyet }}</span>
      </div>
    </div>

      <!-- Ad -->
      <div class="top-label col-12 mb-1" :class="{ 'text-danger': formHatalar.ad }">
        <input 
          id="ad" 
          v-model="localFormData.ad" 
          class="form-control"
          type="text"
        />
        <label for="ad">Ad</label>
        <span v-if="formHatalar.ad" class="error">{{ formHatalar.ad }}</span>
      </div>

      <!-- Açıklama -->
      <div class="top-label col-12 mb-1" :class="{ 'text-danger': formHatalar.aciklama }">
        <textarea 
          id="aciklama" 
          v-model="localFormData.aciklama" 
          class="form-control" 
          rows="5"
        ></textarea>
        <label for="aciklama">Açıklama</label>
        <span v-if="formHatalar.aciklama" class="error">{{ formHatalar.aciklama }}</span>
      </div>

  

      <!-- Bitiş Tarihi -->
      <div class="col-12 mb-1" :class="{ 'text-danger': formHatalar.bitistarih }">
        <Datepicker
          v-model="localFormData.bitistarih"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :enable-time-picker="true"
          placeholder="İş Bitiş Tarihi Seçiniz"
        />
        <span v-if="formHatalar.bitistarih" class="error">{{ formHatalar.bitistarih }}</span>
      </div>

      <!-- Müşteri -->
      <div class="col-12 mb-1" :class="{ 'text-danger': formHatalar.musteri }">
        <v-select
          v-model="localFormData.musteri"
          :options="musteriler"
          label="unvan"
          :reduce="m => m.id"
          placeholder="Müşteri Seçin"
        />
        <span v-if="formHatalar.musteri" class="error">{{ formHatalar.musteri }}</span>
      </div>

      <!-- İş Türü -->
      <div class="col-12 mb-1" :class="{ 'text-danger': formHatalar.istur }">
        <v-select-coklu
          multiple
          v-model="localFormData.istur"
          :options="isturler"
          label="ad"
          :reduce="t => t.id"
          placeholder="İş Türü Seçin"
        />
        <span v-if="formHatalar.istur" class="error">{{ formHatalar.istur }}</span>
      </div>


    

      <!-- Kullanıcılar -->
      <div class="col-12 mb-1" :class="{ 'text-danger': formHatalar.kullanicilar }">
        <v-select-coklu
          multiple
          v-model="localFormData.kullanicilar"
          :options="kullanicilar"
          label="ad"
          :reduce="k => k.id"
          placeholder="Kullanıcılar Seçin"
        />
        <span v-if="formHatalar.kullanicilar" class="error">{{ formHatalar.kullanicilar }}</span>
      </div>

      <!-- Dosyalar -->
      <div class="form-group col-12 mb-3" :class="{ 'text-danger': formHatalar.dosyalar }">
        <label class="form-label fw-bold mb-3">
          <i class="fas fa-paperclip me-2"></i>Dosyalar
        </label>
        
        <!-- Dosya Seçme Alanı ve Seçili Dosyalar: SADECE EKLE MODU -->
        <template v-if="formIslem === 'ekle'">
          <div class="file-upload-container mb-3">
            <div class="file-drop-zone" @drop="handleDrop" @dragover.prevent @dragenter.prevent>
              <input 
                type="file" 
                id="fileInput" 
                ref="fileInput"
                multiple 
                @change="handleFileSelect"
                class="d-none"
              >
              <div class="file-drop-content">
                <i class="fas fa-cloud-upload-alt fa-2x text-primary mb-2"></i>
                <p class="mb-2">Dosyaları buraya sürükleyin veya</p>
                <button 
                  type="button" 
                  class="btn btn-outline-primary btn-sm"
                  @click="$refs.fileInput.click()"
                >
                  <i class="fas fa-plus me-1"></i>Dosya Seç
                </button>
              </div>
            </div>
          </div>
          <!-- Seçili Dosyalar -->
          <div v-if="seciliDosyalar.length > 0" class="selected-files-container">
            <h6 class="mb-2">
              <i class="fas fa-file-alt me-2"></i>Seçili Dosyalar ({{ seciliDosyalar.length }})
            </h6>
            <div class="selected-files-list">
              <div 
                v-for="(file, index) in seciliDosyalar" 
                :key="index"
                class="file-item"
              >
                <div class="file-info">
                  <div class="file-icon">
                    <i :class="getFileIcon(file.name)"></i>
                  </div>
                  <div class="file-details">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-size">{{ formatFileSize(file.size) }}</div>
                  </div>
                </div>
                <button 
                  type="button" 
                  class="btn btn-sm btn-outline-danger file-remove-btn"
                  @click="removeSelectedFile(index)"
                  title="Dosyayı kaldır"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="acorn-icons acorn-icons-bin undefined"><path d="M4 5V14.5C4 15.9045 4 16.6067 4.33706 17.1111C4.48298 17.3295 4.67048 17.517 4.88886 17.6629C5.39331 18 6.09554 18 7.5 18H12.5C13.9045 18 14.6067 18 15.1111 17.6629C15.3295 17.517 15.517 17.3295 15.6629 17.1111C16 16.6067 16 15.9045 16 14.5V5"></path><path d="M14 5L13.9424 4.74074C13.6934 3.62043 13.569 3.06028 13.225 2.67266C13.0751 2.50368 12.8977 2.36133 12.7002 2.25164C12.2472 2 11.6734 2 10.5257 2L9.47427 2C8.32663 2 7.75281 2 7.29981 2.25164C7.10234 2.36133 6.92488 2.50368 6.77496 2.67266C6.43105 3.06028 6.30657 3.62044 6.05761 4.74074L6 5"></path><path d="M2 5H18M12 9V13M8 9V13"></path></svg>
                </button>
              </div>
            </div>
          </div>
        </template>
        <!-- Yüklenmiş Dosyalar: SADECE DÜZENLE MODU -->
        <template v-if="formIslem === 'duzenle'">
          <div v-if="yuklenmisDosyalar.length > 0" class="uploaded-files-container">
            <h6 class="mb-2">
              <i class="fas fa-check-circle me-2 text-success"></i>Yüklenmiş Dosyalar ({{ yuklenmisDosyalar.length }})
            </h6>
            <div class="uploaded-files-list">
              <div 
                v-for="dosya in yuklenmisDosyalar" 
                :key="dosya.id"
                class="file-item uploaded"
              >
                <div class="file-info">
                  <div class="file-icon">
                    <i :class="getFileIcon(dosya.ad)"></i>
                  </div>
                  <div class="file-details">
                    <div class="file-name">{{ dosya.ad }}</div>
                    <div class="file-upload-date">
                      <i class="fas fa-clock me-1"></i>{{ formatDate(dosya.yuklenme_tarihi) }}
                    </div>
                  </div>
                </div>
                <div class="file-actions">
                  <button 
                    type="button" 
                    class="btn btn-sm btn-outline-primary me-1"
                    @click="downloadFile(dosya.id)"
                    title="Dosyayı indir"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="acorn-icons acorn-icons-bin undefined"><path d="M2 14V14.5C2 15.9045 2 16.6067 2.33706 17.1111C2.48298 17.3295 2.67048 17.517 2.88886 17.6629C3.39331 18 4.09554 18 5.5 18H14.5C15.9045 18 16.6067 18 17.1111 17.6629C17.3295 17.517 17.517 17.3295 17.6629 17.1111C18 16.6067 18 15.9045 18 14.5V14"></path><path d="M14 10 10.7071 13.2929C10.3166 13.6834 9.68342 13.6834 9.29289 13.2929L6 10M10 2 10 13"></path></svg>
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-sm btn-outline-danger"
                    @click="yukluDosyalarSil(dosya.id)"
                    title="Dosyayı sil" >
                   <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="acorn-icons acorn-icons-bin undefined"><path d="M4 5V14.5C4 15.9045 4 16.6067 4.33706 17.1111C4.48298 17.3295 4.67048 17.517 4.88886 17.6629C5.39331 18 6.09554 18 7.5 18H12.5C13.9045 18 14.6067 18 15.1111 17.6629C15.3295 17.517 15.517 17.3295 15.6629 17.1111C16 16.6067 16 15.9045 16 14.5V5"></path><path d="M14 5L13.9424 4.74074C13.6934 3.62043 13.569 3.06028 13.225 2.67266C13.0751 2.50368 12.8977 2.36133 12.7002 2.25164C12.2472 2 11.6734 2 10.5257 2L9.47427 2C8.32663 2 7.75281 2 7.29981 2.25164C7.10234 2.36133 6.92488 2.50368 6.77496 2.67266C6.43105 3.06028 6.30657 3.62044 6.05761 4.74074L6 5"></path><path d="M2 5H18M12 9V13M8 9V13"></path></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
        <span v-if="formHatalar.dosyalar" class="error">{{ formHatalar.dosyalar }}</span>
      </div>
    </div>

    <!-- Dosya Yükleme Progress -->
    <div class="col-12 mb-3" v-if="isUploading">
      <div class="upload-progress-container">
        <div class="upload-info">
          <i class="fas fa-spinner fa-spin me-2"></i>
          <span class="upload-filename">{{ uploadFileName }}</span> dosyası yükleniyor...
        </div>
        <div class="progress">
          <div 
            class="progress-bar progress-bar-striped progress-bar-animated" 
            role="progressbar" 
            :style="{ width: `${uploadProgress}%` }"
          >
            {{ uploadProgress }}%
          </div>
        </div>
      </div>
    </div>

    <!-- Butonlar -->
    <div class="d-flex justify-content-around gap-2 mt-4">
      <button class="btn btn-outline-primary" type="button" @click="iptalEt">
        <i class="fas fa-times me-1"></i>İptal
      </button>
      <button class="btn btn-primary w-100" type="submit">
        <i class="fas fa-save me-1"></i>Kaydet
      </button>
    </div>
  </form>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import vSelectCoklu from '@/components/ortak/vSelectCoklu.vue';
import axiosCustom from '@/services/axiosCustom';

export default {
  name: 'IsFormComponent',
  components: {
    vSelect,
    vSelectCoklu,
    Datepicker,
  },
  props: {
    formIslem: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    formKaydetSonrasi: {
      type: Function,
      required: true
    },
    formIptal: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      musteriler: [],
      isturler: [],
      kullanicilar: [],
      localFormData: {},
      formHatalar: {},
      seciliDosyalar: [],
      yuklenmisDosyalar: [],
      isUploading: false,
      uploadProgress: 0,
      uploadFileName: '',
       aciliyetler: [
        { id: '0', ad: 'Beklemede' },
        { id: '1', ad: 'Normal' },
        { id: '2', ad: 'Acil' },
        { id: '3', ad: 'Çok Acil' }
      ],
      durumlar: [
        { id: 'yeni', ad: 'Yeni' },
        { id: 'musteriyeni', ad: 'Müşteri İsteği' },
        { id: 'onaybekliyor', ad: 'Onay Bekliyor' },
        { id: 'devam', ad: 'Devam Ediyor' },
        { id: 'tamamlandi', ad: 'Tamamlandı' },
        { id: 'iptal', ad: 'İptal Edildi' },
      ],
    };
  },
  created() {
    this.initializeComponent();
  },
  watch: {
    formData: {
      handler(newFormData) {
        this.updateLocalFormData(newFormData);
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    // Initialize component safely
    async initializeComponent() {
      // First initialize form data
      this.localFormData = this.initializeFormData();
      // Load data
      await this.loadInitialData();
    },
    // Initialize form data with proper defaults
    initializeFormData() {
      const defaultData = {
        ad: '',
        durum: 'yeni',
        aciklama: '',
        aciliyet: 1,
        bitistarih: null,
        musteri: null,
        istur: [],
        kullanicilar: [],
        ...this.formData
      };
      return {
        ...defaultData,
        bitistarih: this.parseDateForPicker(defaultData.bitistarih),
        istur: this.parseArrayField(defaultData.istur),
        kullanicilar: this.parseArrayField(defaultData.kullanicilar),
      };
    },
    // Load all required data
    async loadInitialData() {
      try {
        await Promise.all([
          this.musterilerGetir(),
          this.isturlerGetir(),
          this.kullanicilarGetir(),
          this.yuklenmisDosyalarGetir(),
        ]);
      } catch (error) {
        console.error("Veri yükleme hatası:", error);
        this.$toast && this.$toast.error("Veri yükleme hatası");
      }
    },
    // Update local form data when props change
    updateLocalFormData(newFormData) {
      const updatedData = {
        ...this.localFormData,
        ...newFormData,
        bitistarih: this.parseDateForPicker(newFormData.bitistarih),
        istur: this.parseArrayField(newFormData.istur),
        kullanicilar: this.parseArrayField(newFormData.kullanicilar),
      };
      this.localFormData = updatedData;
    },
    // Parse array fields safely
    parseArrayField(field) {
      if (!field) return [];
      if (Array.isArray(field)) return field;
      if (typeof field === 'string') {
        try {
          return field.split(',').filter(item => item.trim());
        } catch (error) {
          console.warn("Array parse hatası:", error);
          return [];
        }
      }
      return [];
    },
    // Parse date for picker component
    parseDateForPicker(dateValue) {
      if (!dateValue || dateValue === '' || dateValue === 'null' || dateValue === 'undefined') {
        return null;
      }
      if (dateValue instanceof Date) return dateValue;
      // If it's already a properly formatted date string
      if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
        // Convert to Date object
        return new Date(dateValue.replace(' ', 'T'));
      }
      // If it's a date without time
      if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return new Date(dateValue + 'T00:00:00');
      }
      // Try to convert to Date
      try {
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) {
          return null;
        }
        return date;
      } catch (error) {
        console.warn("Date parse hatası:", error);
        return null;
      }
    },
    // Format date for API
    formatDateForApi(dateObj) {
      if (!dateObj) return '';
      const pad = n => String(n).padStart(2, '0');
      return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())} ${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;
    },
    // API Methods
    async musterilerGetir() {
      try {
        const response = await axiosCustom.get("musteriler");
        this.musteriler = response.data || [];
      } catch (error) {
        console.error("Müşteriler alma hatası:", error);
        throw error;
      }
    },
    async isturlerGetir() {
      try {
        const response = await axiosCustom.get("isturler");
        this.isturler = response.data || [];
      } catch (error) {
        console.error("İş türleri alma hatası:", error);
        throw error;
      }
    },
    async kullanicilarGetir() {
      try {
        const response = await axiosCustom.get("kullanicilar");
        this.kullanicilar = response.data || [];
      } catch (error) {
        console.error("Kullanıcılar alma hatası:", error);
        throw error;
      }
    },
    async yuklenmisDosyalarGetir() {
      try {
        const response = await axiosCustom.get(`isler/dosyalar/${this.localFormData.id}`);
        this.yuklenmisDosyalar = response.data || [];
      } catch (error) {
        console.error("Dosya alma hatası:", error);
        throw error;
      }
    },
    // Form validation
    formDogrula() {
      this.formHatalar = {};
      let kontrol = true;
      // Required field validations
      const requiredFields = [
        { field: 'ad', message: 'Ad boş bırakılamaz.' },
        { field: 'aciklama', message: 'Açıklama boş bırakılamaz.' },
        { field: 'musteri', message: 'Müşteri boş bırakılamaz.' },
        { field: 'istur', message: 'İş Türü boş bırakılamaz.' },
      ];
      requiredFields.forEach(({ field, message }) => {
        const value = this.localFormData[field];
        if (!value || (Array.isArray(value) && value.length === 0)) {
          this.formHatalar[field] = message;
          kontrol = false;
        }
      });
      // Date validations
      if ( this.localFormData.bitistarih) {
   
       this.localFormData.bitistarih instanceof Date ? this.localFormData.bitistarih : new Date(this.localFormData.bitistarih);
      
      }

  // Aciliyet kontrolü
    if (this.localFormData.aciliyet === null || this.localFormData.aciliyet === undefined) {
      this.formHatalar.aciliyet = 'Aciliyet durumu seçilmelidir';
      kontrol = false;
    }


      return kontrol;
    },
    // Form submission
    async gonder() {
      if (!this.formDogrula()) {
        return;
      }
      const formData = this.prepareFormData();
      try {
        let response;
        if (this.formIslem === "duzenle") {
          response = await axiosCustom.post(`isler/duzenle/${this.localFormData.id}`, formData);
          this.$toast && this.$toast.success("İş Düzenlendi");
        } else {
          response = await axiosCustom.post("isler/ekle", formData);
          this.$toast && this.$toast.success("Yeni İş Eklendi");
        }
        // Upload files if any
        if (this.seciliDosyalar.length > 0) {
          await this.cokluDosyalarYukle(response.data.id);
        }
        this.formKaydetSonrasi();
      } catch (error) {
        console.error("Form gönderme hatası:", error);
        this.$toast && this.$toast.error("Kaydetme hatası");
      }
    },
    // Prepare form data for submission
    prepareFormData() {
      const formData = new FormData();
      // Add form fields
      Object.keys(this.localFormData).forEach(key => {
        let value = this.localFormData[key];
        if ( key === 'bitistarih') {
          value = this.formatDateForApi(value);
        }
        if (value !== null && value !== undefined) {
          if (Array.isArray(value)) {
            formData.append(key, value.join(','));
          } else {
            formData.append(key, value);
          }
        }
      });
      return formData;
    },
    // File handling methods - YENİ YÖNTEMLER
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.seciliDosyalar = [...this.seciliDosyalar, ...files];
    },
    handleDrop(event) {
      event.preventDefault();
      const files = Array.from(event.dataTransfer.files);
      this.seciliDosyalar = [...this.seciliDosyalar, ...files];
    },
    removeSelectedFile(index) {
      this.seciliDosyalar.splice(index, 1);
    },
    getFileIcon(fileName) {
      if (!fileName || typeof fileName !== 'string' || !fileName.includes('.')) {
        return 'fas fa-file text-secondary';
      }
      const extension = fileName.split('.').pop().toLowerCase();
      const iconMap = {
        pdf: 'fas fa-file-pdf text-danger',
        doc: 'fas fa-file-word text-primary',
        docx: 'fas fa-file-word text-primary',
        xls: 'fas fa-file-excel text-success',
        xlsx: 'fas fa-file-excel text-success',
        ppt: 'fas fa-file-powerpoint text-warning',
        pptx: 'fas fa-file-powerpoint text-warning',
        jpg: 'fas fa-file-image text-info',
        jpeg: 'fas fa-file-image text-info',
        png: 'fas fa-file-image text-info',
        gif: 'fas fa-file-image text-info',
        txt: 'fas fa-file-alt text-secondary',
        zip: 'fas fa-file-archive text-dark',
        rar: 'fas fa-file-archive text-dark',
      };
      return iconMap[extension] || 'fas fa-file text-secondary';
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    downloadFile(dosyaId) {
      // Dosya indirme işlemi
      window.open(`/api/isler/dosyalar/${dosyaId}/indir`, '_blank');
    },
    // Mevcut dosya işleme yöntemleri (eski MultiFileComponent ile uyumluluk için)
    seciliDosyalarDegistir({ files, index, type }) {
      if (type === "ekle") {
        this.seciliDosyalar = files;
      } else if (type === "sil") {
        this.seciliDosyalar.splice(index, 1);
      }
    },
    async cokluDosyalarYukle(id) {
      const CHUNK_SIZE = 1024 * 1024; // 1 MB
      try {
        for (const file of this.seciliDosyalar) {
          const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
          this.uploadFileName = file.name;
          this.isUploading = true;
          for (let chunk = 0; chunk < totalChunks; chunk++) {
            const start = chunk * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, file.size);
            const chunkData = file.slice(start, end);
            const formData = new FormData();
            formData.append("fileName", file.name);
            formData.append("fileChunk", chunkData);
            formData.append("currentChunk", chunk);
            formData.append("totalChunks", totalChunks);
            await axiosCustom.post(`isler/dosyalaryukle/${id}`, formData);
            // Update progress
            this.uploadProgress = Math.round(((chunk + 1) / totalChunks) * 100);
          }
        }
      } catch (error) {
        console.error('Dosya yükleme hatası:', error);
        this.$toast && this.$toast.error('Dosya yükleme hatası');
        throw error;
      } finally {
        this.isUploading = false;
        this.uploadProgress = 0;
        this.uploadFileName = '';
      }
    },
    async yukluDosyalarSil(id) {
      try {
        const result = await this.$swal({
          title: "Emin misiniz?",
          text: "Bu dosya silinecek!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Evet, sil!",
          cancelButtonText: "Vazgeç"
        });
        if (result.isConfirmed) {
          await axiosCustom.post(`isler/dosyalarsil/${id}`);
          this.$toast && this.$toast.success("Dosya Silindi");
          await this.yuklenmisDosyalarGetir();
        }
      } catch (error) {
        console.error("Dosya silme hatası:", error);
        this.$toast && this.$toast.error("Dosya silme hatası");
      }
    },
    // Form cancel
    iptalEt() {
      this.formIptal();
    },
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.top-label {
  position: relative;
}

.top-label label {
  position: absolute;
  top: -10px;
  left: 10px;
  background: white;
  padding: 0 5px;
  font-size: 0.875rem;
  color: #6c757d;
  z-index: 1;
}

.form-control:focus + label {
  color: #0d6efd;
}

/* Dosya Yükleme Stilleri */
.file-upload-container {
  margin-bottom: 1rem;
}

.file-drop-zone {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
  cursor: pointer;
}

.file-drop-zone:hover {
  border-color: #0d6efd;
  background-color: #e7f3ff;
}

.file-drop-zone.drag-over {
  border-color: #0d6efd;
  background-color: #e7f3ff;
}

.file-drop-content p {
  color: #6c757d;
  margin-bottom: 0.5rem;
}

/* Seçili Dosyalar */
.selected-files-container, .uploaded-files-container {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.selected-files-container h6, .uploaded-files-container h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.selected-files-list, .uploaded-files-list {
  max-height: 200px;
  overflow-y: auto;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background-color: white;
  border: 1px solid #ffffff;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
}

.file-item:hover {
  border-color: #0d6efd;
}

.file-item.uploaded {
  background-color: #ffffff;
}

.file-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.file-icon {
  margin-right: 0.75rem;
  font-size: 1.2rem;
  width: 24px;
  text-align: center;
}

.file-details {
  flex: 1;
}

.file-name {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  word-break: break-word;
}

.file-size {
  font-size: 0.875rem;
  color: #6c757d;
}

.file-upload-date {
  font-size: 0.875rem;
  color: #6c757d;
}

.file-actions {
  display: flex;
  gap: 0.25rem;
}

.file-remove-btn {
  border: none;
  background: none;
  color: #dc3545;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.file-remove-btn:hover {
  background-color: #dc3545;
  color: white;
}

/* Yükleme Progress */
.upload-progress-container {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem;
}

.upload-info {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  color: #495057;
}

.upload-filename {
  font-weight: 500;
}

.progress {
  height: 20px;
  background-color: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  background: linear-gradient(90deg, #0d6efd, #0056b3);
  height: 100%;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Scrollbar Styling */
.selected-files-list::-webkit-scrollbar,
.uploaded-files-list::-webkit-scrollbar {
  width: 6px;
}

.selected-files-list::-webkit-scrollbar-track,
.uploaded-files-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.selected-files-list::-webkit-scrollbar-thumb,
.uploaded-files-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.selected-files-list::-webkit-scrollbar-thumb:hover,
.uploaded-files-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive Design */
@media (max-width: 768px) {
  .file-drop-zone {
    padding: 1.5rem 1rem;
  }
  
  .file-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .file-actions {
    align-self: flex-end;
  }
  
  .file-info {
    width: 100%;
  }
}

/* Animasyonlar */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.file-item {
  animation: fadeIn 0.3s ease;
}

/* Drag & Drop States */
.file-drop-zone.drag-over {
  border-color: #0d6efd;
  background-color: #e7f3ff;
  transform: scale(1.02);
}

.file-drop-zone.drag-over .file-drop-content {
  color: #0d6efd;
}

/* Button Hover Effects */
.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* File Icon Colors */
.text-danger { color: #dc3545 !important; }
.text-primary { color: #0d6efd !important; }
.text-success { color: #198754 !important; }
.text-warning { color: #ffc107 !important; }
.text-info { color: #0dcaf0 !important; }
.text-secondary { color: #6c757d !important; }
.text-dark { color: #212529 !important; }
</style>